import { apiFetch } from '../api';

export type StoreGroupingMode = 'products' | 'groups';

let defaultGroupingPromise: Promise<StoreGroupingMode | null> | null = null;

const parseGrouping = (value: unknown): StoreGroupingMode | null => {
  if (typeof value !== 'string') return null;
  const normalized = value.toLowerCase();
  if (normalized === 'products' || normalized === 'groups') {
    return normalized;
  }
  return null;
};

export async function fetchDefaultGrouping(): Promise<StoreGroupingMode | null> {
  if (!defaultGroupingPromise) {
    defaultGroupingPromise = (async () => {
      const res = await apiFetch('/api/settings/store');
      if (!res.ok) return null;
      const json = await res.json();
      return parseGrouping(json.default_grouping);
    })().catch(() => null);
  }
  return defaultGroupingPromise;
}
